<h2 mat-dialog-title>Add a widget</h2>
<mat-dialog-content>
  <div class="widget-catalog">
    @for (definition of registry; track definition.type) {
      <button type="button" class="catalog-item" (click)="select(definition)">
        <mat-icon>{{ definition.icon }}</mat-icon>
        <div class="catalog-item-text">
          <span class="catalog-item-name">{{ definition.name }}</span>
          <span class="catalog-item-description">{{
            definition.description
          }}</span>
        </div>
      </button>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
